/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CSSObject } from "styled-components";
import { theme, StickyBar, Button, Message } from "@nordcloud/gnui";
import { TopBar } from "~/components";
import { useDisclosure } from "~/hooks";

/**
 *
 * Used to display temporary message to the users.
 * Don't remove this.
 */
export function InfoBar({
  children,
  css,
  ...rest
}: Omit<React.ComponentProps<typeof TopBar>, "onClose"> & {
  css?: CSSObject;
}) {
  const { isOpen, close } = useDisclosure(true);

  if (isOpen) {
    return (
      <StickyBar
        css={Object.assign(
          {
            // Default position `sticky` conflicts with previous billing period bar
            position: "relative",
            // Don't overlap sidebars
            zIndex: theme.zindex.default,
            padding: 0,
            paddingLeft: "3.5rem",
          },
          css
        )}
        {...rest}
      >
        <Message status="notification" image="info" css={{ width: "100%" }}>
          <span>{children}</span>
          <Button
            size="sm"
            severity="low"
            icon="close"
            css={{
              marginLeft: "auto",
            }}
            onClick={close}
          />
        </Message>
      </StickyBar>
    );
  }

  return null;
}
